import React, { useState, useEffect } from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormContainer from '../components/FormContainer';
import { savePaymentMethod } from '../slices/cartSlice';
import CheckoutSteps from '../components/CheckoutSteps';
import { useTranslation } from 'react-i18next';
const PaymentScreen = () => {
  
  const [paymentMethod, setPaymentMethod] = useState('ClicToPay');
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir().toLowerCase() === 'rtl';

  const { deviseInfo } = useSelector((state) => state.devise);

  useEffect(() => {
    if (!shippingAddress) {
      navigate('/shipping');
    }
  }, [shippingAddress, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));
    navigate('/placeorder');
  };
  
 
  return (
    <FormContainer wide>
      <CheckoutSteps step1 step2 step3 />
      <h1 dir={isRTL ? 'rtl' : 'ltr'}>{t('mode')}</h1>
      <Form onSubmit={submitHandler} dir={isRTL ? 'rtl' : 'ltr'}>
        <Form.Group>
          <Form.Label as='legend'>{t('method')}</Form.Label>
          
          {deviseInfo === "TND" && (
          <Col>
            <Form.Check
              type='switch'
              className='my-2'
              label='ClictoPay Tunisia'
              id='ClicToPay'
              name='paymentMethodclic'
              value='ClicToPay'
              //defaultChecked={true}
              onChange={(e) => setPaymentMethod(e.target.value)}
            ></Form.Check>
          </Col>
          )
         } 
          
         
        </Form.Group>
        <br />
        <Button type='submit' className='btn-teal w-100'>
        {t('Continue')}
        </Button>
      </Form>
    </FormContainer>
  );
};

export default PaymentScreen;
